import { render, staticRenderFns } from "./SidebarContent.vue?vue&type=template&id=5b0a3c4e&scoped=true"
import script from "./MemberCardSidebar.js?vue&type=script&lang=js&external"
export * from "./MemberCardSidebar.js?vue&type=script&lang=js&external"
import style0 from "./SidebarContent.vue?vue&type=style&index=0&id=5b0a3c4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a3c4e",
  null
  
)

export default component.exports